














import { Component, Vue } from "vue-property-decorator";
import Menu from "./components/Menu.vue";

@Component({
  components: {
    Menu
  }
})
export default class App extends Vue {
  mounted() {
  }
  get isAuthenticated() {
    return this.$store.state.user.isAuthenticated;
  }
}
